import React, { FC } from 'react'
import SlidesScreen from './SlidesScreen'
import { SlidesScreenCreatorProps } from './types'

const SlidesScreenCreator: FC<SlidesScreenCreatorProps> = props => {

  const { slidesDeckVersion, ...modifiedProps } = props

  return  slidesDeckVersion !== null ? <SlidesScreen { ...modifiedProps } /> : null

}

export default SlidesScreenCreator
